import PropTypes from 'prop-types';
import { useState } from 'react';
import { Box } from '@mui/material';
import SegmentedControl from '../../../components/settings/SegmentedControl';
import SettingsSection from '../../../components/settings/SettingsSection';
import OpenHour from './OpenHour';
import ClosuresTab from './ClosuresTab';
import OutOfHoursTab from './OutOfHoursTab';

// ─── tab definitions ──────────────────────────────────────────────────────────

const TABS = [
    { value: 'weekly', label: 'Weekly Schedule' },
    { value: 'closures', label: 'Closures & Holidays' },
    { value: 'out-of-hours', label: 'Out-of-Hours Message' },
];

// ─── component ────────────────────────────────────────────────────────────────

export default function OpenHourTabs({ hoursList, practiceId, canEdit }) {
    const [activeTab, setActiveTab] = useState('weekly');

    return (
        <SettingsSection
            id="opening-hours"
            icon="solar:clock-circle-bold"
            title="Opening Hours"
            description="Set your practice opening times, closures, and out-of-hours messaging"
            iconColor="#06b6d4"
        >
            <Box sx={{ mb: 2.5 }}>
                <SegmentedControl tabs={TABS} value={activeTab} onChange={setActiveTab} />
            </Box>

            {activeTab === 'weekly' && (
                <OpenHour hoursList={hoursList} practiceId={practiceId} canEdit={canEdit} />
            )}
            {activeTab === 'closures' && (
                <ClosuresTab practiceId={practiceId} canEdit={canEdit} />
            )}
            {activeTab === 'out-of-hours' && (
                <OutOfHoursTab practiceId={practiceId} canEdit={canEdit} />
            )}
        </SettingsSection>
    );
}

OpenHourTabs.propTypes = {
    hoursList: PropTypes.array,
    practiceId: PropTypes.any,
    canEdit: PropTypes.bool,
};

OpenHourTabs.defaultProps = {
    hoursList: [],
    practiceId: null,
    canEdit: false,
};
